<template>
  <tr>
    <td style="width: 25px">{{index + 1}}</td>
    <td class="text-center" style="white-space: nowrap; width: 150px;">
      <router-link :to="{path: path, query: {'dealName': entry.DealName}}">
        {{entry.DealName}}
      </router-link>
    </td>
    <td class="text-center" style="width: 70px">
      <router-link 
        :to="{path: entry.DealName.startsWith('ACIS') ? '/acis_analysis' : '/bond_analysis', query: {dealName : entry.DealName, bondName: entry.BondName}}" 
        v-if="!entry.DealName.startsWith('CIRT')">
        {{entry.BondName}}
      </router-link>
    </td>
    <td class="text-right" style="width: 100px">
      <span>{{entry.OwnedFaceAmt | dollarValue(0)}}</span>
    </td>
    <td class="text-right" style="width: 140px">
      <span>{{entry.currentBalance | dollarValue(0)}}</span>
    </td>
    <td class="text-right" style="width: 70px">
      <span>{{entry.Margin}}</span>
      </td>
    <td v-for="(result, scIndex) of items"
      :class="{
        color_hover: result.Yield != 'Missing scenario',
        color_missingScenario: result.Yield == 'Missing scenario'
      }"
      :key="scIndex" @click="selectCell(index, scIndex)">{{result[selectedResultType] | rounding}}</td>
  </tr>
</template>

<script>
import formatter from "../../utilities/Formatter";
import CalculationSettingsInput from '../dealInformation/CalculationSettingsInput'

export default {
  props: {
    entry: Object,
    index: Number,
    deals: Array,
    selectedResultType: String,
    scenariosNames: Array
  },
  computed: {
    items() {
      const results = this.entry.Results || [];
      const itemsMap = results.reduce
        ? results.reduce((acc, { scenarioName, ...item }) => acc.set(scenarioName, item), new Map()) : new Map();
      return this.scenariosNames.map(sc => itemsMap.get(sc.name) || {});
    },
    path() {
      let redirectPage = '/deal_analysis';
      if (this.entry && this.entry.DealName) {
        let dealName = this.entry.DealName;
        if (dealName.startsWith('ACIS')) {
          redirectPage = '/acis_analysis'
        } else if (dealName.startsWith('CIRT')) {
          redirectPage = '/cirt_analysis';
        }
      }
      return redirectPage;
    }
  },
  methods: {
    formatUSD: function(val, event) {
      return formatter.formatDollarValue(val)
    },
    selectCell: function (index, scIndex) {
      if (this.entry.Results[scIndex].Yield != "Missing scenario") { this.$emit('selected', {entryIndex: index, scenarioIndex: scIndex}); }
    }
  },
  components: {
    CalculationSettingsInput
  }
}
</script>

<style lang="scss">
.color_hover:hover {
  background-color: rgba(23,162,184,.3);
  cursor: pointer;
}
.color_missingScenario {
  background-color: #ff365636;
}
</style>